import React from 'react';
import PropTypes from 'prop-types';
import RenderPropertyGroupsInputField from 'components/form/InputFields/AutoCompleteField/RenderPropertyGroupsInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, change, getFormValues, Field, isInvalid } from 'redux-form';
import RenderLocalisationInputField from 'components/form/InputFields/RenderLocalisationInputField';

class PropertiesCreateForm extends React.Component {
    render() {
        const {
            form,
            handleSubmit,
            handleSubmitForm,
            invalid,
            localisationFields,
            pristine,
            submitting,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderPropertyGroupsInputField }
                                    fullWidth={ true }
                                    label={ 'resources.properties.fields.property_group_id' }
                                    name='property_group_id'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <RenderLocalisationInputField
                                    fields={ localisationFields }
                                    form={ form }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

PropertiesCreateForm.defaultProps = {
    localisationFields: [
        {
            maxLength: 255,
            name: 'name',
            required: true,
            type: 'text',
        },
        {
            maxLength: 325,
            name: 'description',
            required: true,
            type: 'textarea',
        },
    ],
};

PropertiesCreateForm.propTypes = {
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    localisationFields: PropTypes.array,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
};

const formName = 'properties_create';

const mapStateToProps = (state) => {
    return {
        formValues: getFormValues(formName)(state),
        invalid: isInvalid(formName)(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeFieldValue: (field, value) => {
            dispatch(change(formName, field, value));
        },
        form: formName,
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.property_group_id) {
                errors.property_group_id = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(PropertiesCreateForm);



// WEBPACK FOOTER //
// ./src/pages/properties/create/PropertiesCreateForm.js